// Generated by CoffeeScript 1.12.7
(function() {
  var ng;

  require('./multi_order_by');

  require('./st_element_id');

  ng = angular;

  angular.module('smart-table').directive('stMultiSort', [
    'stConfig', '$parse', '$rootScope', 'stUniqueId', function(stConfig, $parse, $rootScope, stUniqueId) {
      return {
        restrict: 'A',
        require: '^stTable',
        link: function(scope, element, attr, ctrl) {
          var classAscent, classDescent, elementId, getter, index, predicate, sort, sortDefault, stateClasses;
          predicate = attr.stMultiSort;
          getter = $parse(predicate);
          index = 0;
          classAscent = attr.stClassAscent || stConfig.sort.ascentClass;
          classDescent = attr.stClassDescent || stConfig.sort.descentClass;
          stateClasses = [classAscent, classDescent];
          sortDefault = void 0;
          elementId = stUniqueId.generate();

          /*
          Use our custom orderBy filter, which supports reversing rows independently
           */
          ctrl.setSortFunction('multiOrderBy');

          /*
          Sort the rows.
          @param {Boolean} holdingShiftKey
           */
          sort = function(holdingShiftKey) {
            var base, reverse, tableState;
            index++;
            tableState = ctrl.tableState();
            if ((base = tableState.sort).predicate == null) {
              base.predicate = [];
            }
            reverse = index % 2 === 0;
            predicate = ng.isFunction(getter(scope)) ? getter(scope) : attr.stMultiSort;
            (function() {
              var indexOfExistingSort;
              indexOfExistingSort = (function() {
                var i, ref, sortConfig;
                ref = ctrl.tableState().sort.predicate;
                for (i in ref) {
                  sortConfig = ref[i];
                  if (sortConfig.elementId === elementId) {
                    return i;
                  }
                }
                return -1;
              })();
              if (indexOfExistingSort !== -1) {
                return tableState.sort.predicate.splice(indexOfExistingSort, 1);
              }
            })();
            (function() {
              index = index % 2 === 0 ? 2 : 1;
              element.removeClass(stateClasses[index % 2]).addClass(stateClasses[index - 1]);
              if (!holdingShiftKey) {
                return $rootScope.$broadcast('clearOtherSortClasses', elementId);
              }
            })();
            (function() {
              if (!holdingShiftKey) {
                tableState.sort.predicate.length = 0;
              }
              return tableState.sort.predicate.push({
                elementId: elementId,
                predicate: predicate,
                reverse: reverse === true
              });
            })();
            tableState.pagination.start = 0;
            return ctrl.pipe();
          };
          if (attr.stSortDefault) {
            sortDefault = scope.$eval(attr.stSortDefault) != null ? scope.$eval(attr.stSortDefault) : attr.stSortDefault;
          }
          if (sortDefault) {
            index = sortDefault === 'reverse' ? 1 : 0;
            sort();
          }
          element.bind('click', function(e) {
            if (!predicate) {
              return;
            }
            return scope.$apply(function() {
              return sort(e.shiftKey || e.ctrlKey);
            });
          });
          return scope.$on('clearOtherSortClasses', function(e, sortedElementId) {
            if (sortedElementId !== elementId) {
              index = 0;
              return element.removeClass(classAscent).removeClass(classDescent);
            }
          });
        }
      };
    }
  ]);

}).call(this);
